import Card from '@material-ui/core/Card';
import styled from 'styled-components';

export default styled(Card)`
  && {
    border-radius: ${props => props.radius || 0};
    margin: ${props => props.margin || 20}px auto;
    padding: ${props => props.padding || '20px'};
    display: flex;
    box-shadow: none;
    flex-direction: ${props => (props.row ? 'row' : 'column')};
    z-index: 2;
    max-width: ${props => (props.maxwidth ? props.maxwidth + 'px' : '100%')};
    cursor: ${props =>
      props.onClick ? 'pointer' : props.pointer ? 'pointer' : 'default'};

    @media (max-width: 600px) {
      height: ${props => props.height};
    }
  }
`;
